import { IonContent, IonInput, IonPage, IonText, IonIcon,IonSpinner } from "@ionic/react";
import { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router";
import DataTable from "react-data-table-component";
import service from "../../../Service/service";
import Head from "../../Header";
import Select from "react-select"
import Sidebar from "../../Sidebar";
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";
const HRBusinessunit: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [employeelist, setEmployeelist] = useState([]);
    const [loading,setloading]=useState(false)
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);

    /*.............. View & Upadate ........... */
    const [businessUnitCode, setBusinessUnitCode] = useState("");
    const [businessUnitName, setBusinessUnitName] = useState("");
    const [businessUnitHead, setBusinessUnitHead] = useState("");
    const [businessUnitAlter, setBusinessUnitAlter] = useState("");

    const [unitCode, setUnitCode] = useState("");
    const [unitName, setUniteName] = useState("");
    const [unitHead, setUnitHead] = useState("");
    const [unitAlter, setUnitAlter] = useState("");
    const [id, setId] = useState("")

    /*................... Businessunit Auto complete .................. */


    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen1) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen1]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [

        ...employeelist.map((state: any) => ({
            value: state.id,
            label: state.name,
        })),

    ];
    const handleBusinessChange = (selectedOption: any) => {
        setUnitHead(selectedOption.value)
    };

    /*................... view businessunit  Auto complete .................. */


    const handleBusinessUpdateChange = (selectedOption: any) => {
        setBusinessUnitHead(selectedOption.value)

    };

    /*................... Departmenthead Auto complete .................. */


    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholder1 = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Department Head</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const option1 = [

        ...employeelist.map((state: any) => ({
            value: state.id,
            label: state.name,
        })),

    ];
    const handleBusiheadChange = (selectedOption1: any) => {
        setUnitAlter(selectedOption1.value)
    };
    const back = () => {
        history.goBack();
    }
    /*................... view business alter Auto complete .................. */


    const handleBusiheadUpdateChange = (selectedOption1: any) => {
        setBusinessUnitAlter(selectedOption1.value)
    };
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "100px",
        },
        {
            name: "BU Code",
            selector: (itm: any) => itm.businessUnitCode,
            sortable: true,
            width: "200px",
        },
        {
            name: "BU Name",
            selector: (itm: any) => itm.businessUnitName,
            sortable: true,
            width: "200px",
        },
        {
            name: "BU Head",
            selector: (itm: any) => itm.businessUnitHead,
            sortable: true,
            width: "250px",
        },
        {
            name: "BU Alternate",
            selector: (itm: any) => itm.businessUnitAlternate,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )

        }
    ]

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

/*..............Search filter................*/

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

/*.....................Getall Businessunit name Api..................*/

    const LoadBussinessUnit = () => {
        setloading(true)
        service.GetAllBussinessunitName()
            .then((response) => {
                console.log(response, "data")
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(()=>{
                setTimeout(() => {
                    setloading(false);
                }, 500); 

            })
    }

    useEffect(() => {
        LoadBussinessUnit();
        LoadEmployeeList();
    }, []);

    //...............EmployeeList Api.............//

    const LoadEmployeeList = () => {
        service.GetAllEmployeeNameDropDown()
            .then((response) => {
                console.log("All Employee Names")
                console.log(response);
                if (response.data === null || response.data.Data === null) {
                    setEmployeelist([])
                }
                else {
                    setEmployeelist(response.data.Data);
                }
            })
    }

//......................View Businessunit Modal..................//

    const openmodal = (id: any) => {
        setId(id)
        setModalopen(true);
        service.ViewBusinessUnitById(id)
            .then((response) => {
                console.log(response);
                console.log("RESPONSE", response.data.Data);
                if (response.data.Data.businessUnitName === null || response.data.Data.businessUnitName === "") {
                    setBusinessUnitName("");
                }
                else {
                    setBusinessUnitName(response.data.Data.businessUnitName)
                }
                if (response.data.Data.businessUnitCode === null || response.data.Data.businessUnitCode === "") {
                    setBusinessUnitCode("");
                }
                else {
                    setBusinessUnitCode(response.data.Data.businessUnitCode)
                }
                if (response.data.Data.businessUnitHead === null || response.data.Data.businessUnitHead === "") {
                    setBusinessUnitHead("");
                }
                else {
                    setBusinessUnitHead(response.data.Data.businessUnitHead)
                }
                if (response.data.Data.businessUnitAlternate === null || response.data.Data.businessUnitAlternate === "") {
                    setBusinessUnitAlter("");
                }
                else {
                    setBusinessUnitAlter(response.data.Data.businessUnitAlternate)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const openmodal1 = () => {
        setModalopen1(true);
        setUnitCode("");
        setUniteName("");
        setUnitHead("");
        setUnitAlter("");
    }

    const closemodal = () => {
        setModalopen(false);
        setBusinessUnitName("");
        setBusinessUnitCode("");
        setBusinessUnitHead("");
        setBusinessUnitAlter("");
    }

    const closemodal1 = () => {
        setModalopen1(false);
    }

//..................Create Businessunit...................//

    const Create = () => {
        if (unitCode.length === 0) {
            swal("", "Please Enter Business Code", "info")
            return;
        }
        else if (unitName.length === 0) {
            swal("", "Please Enter Business Name", "info")
            return;
        }
        // else if (unitHead.length === 0) {
        //     swal("", "Please Enter Business Head", "info")
        //     return;
        // }
        // else if (unitAlter.length === 0) {
        //     swal("", "Please Enter Business Alternate", "info")
        //     return;
        // }
        else {
            console.log("success")
            service.CreateBusinessUnit(unitName, unitCode, unitHead, unitAlter)
                .then((response) => {
                    console.log("resss", response);
                    if (response.data.status === "200") {
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", response.data.message, "error");
                    }
                })
        }
    }

//........................Update Businessunit......................//

    const Update = () => {
        service.UpdateBusinessUnit(id, businessUnitName, businessUnitCode, businessUnitHead, businessUnitAlter)
            .then((response) => {
                if (response.data.status == '200') {
                    swal("", "Updated Sucessfully", "success");
                    window.location.reload();
                } else {
                    swal("", response.data.message, "error")
                }

            })
            .catch((error) => {
                swal(error);
            });
    }

    const handleHead = (e: any) => {
        setBusinessUnitHead(e.target.value);
    }

    const handleHeadAlter = (e: any) => {
        setBusinessUnitAlter(e.target.value);
    }

    const handleCreateHead = (e: any) => {
        setUnitHead(e.target.value);
    }

    const handleCreateHeadAlter = (e: any) => {
        setUnitAlter(e.target.value);
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Business Unit</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Bussiness Unit</a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
 
   {/*......................View Modal......................*/}

                    <Modal
                        dialogClassName="modal-dialog modal-lg"
                        // id="logouts-modal"
                        show={modalopen}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">View Business Unit</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Business Code <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={businessUnitCode} onIonChange={(e: any) => setBusinessUnitCode(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={businessUnitName} onIonChange={(e: any) => setBusinessUnitName(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Head <span className="text-danger">*</span></label>
                                    <div>
                                        <Select

                                            options={options}
                                            value={options.find((option) => option.value === businessUnitHead) || null}
                                            onChange={handleBusinessUpdateChange}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable
                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                            className="custom-select6"
                                        />
                                        {/* <select value={businessUnitHead} className="select" onChange={(e: any) => handleHead(e)}>
                                            <option value="" disabled selected>Select Head</option>
                                            {employeelist.map((state: any) => (
                                                <option key={state.id} value={state.id}>
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select> */}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Alternate - Assignment <span className="text-danger">*</span></label>
                                    <div>
                                        <Select

                                            options={option1}
                                            value={option1.find((option) => option.value === businessUnitAlter) || null}
                                            onChange={handleBusiheadUpdateChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholder1 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator1,
                                            }}
                                            className="custom-select5"
                                        />
                                    </div>
                                </div>

                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                </div>
                            </form>
                        </div>
                    </Modal>

   {/*......................View Modal......................*/}

                    <Modal
                        dialogClassName="modal-dialog modal-lg"
                        // id="logouts-modal"
                        show={modalopen1}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Create Business Unit</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Code <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={unitCode} placeholder="Ex: BU Code - 1" onIonChange={(e: any) => setUnitCode(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={unitName} onIonChange={(e: any) => setUniteName(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Head </label>
                                    <div>
                                        <Select

                                            options={options}
                                            value={options.find((option) => option.value === unitHead) || null}
                                            onChange={handleBusinessChange}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable
                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                            className="custom-select6"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>BU Alternate - Assignmemt </label>
                                    <div>
                                        <Select

                                            options={option1}
                                            value={option1.find((option) => option.value === unitAlter) || null}
                                            onChange={handleBusiheadChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholder1 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator1,
                                            }}
                                            className="custom-select5"
                                        />
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                                </div>
                            </form>
                        </div>
                    </Modal>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default HRBusinessunit